import { render, staticRenderFns } from "./address-save.vue?vue&type=template&id=32bc1567"
import script from "./address-save.vue?vue&type=script&lang=js"
export * from "./address-save.vue?vue&type=script&lang=js"
import style0 from "./address-save.vue?vue&type=style&index=0&id=32bc1567&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports